import { render, staticRenderFns } from "./dialogNotification.vue?vue&type=template&id=375cd547&scoped=true"
import script from "./dialogNotification.vue?vue&type=script&lang=js"
export * from "./dialogNotification.vue?vue&type=script&lang=js"
import style0 from "./dialogNotification.vue?vue&type=style&index=0&id=375cd547&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375cd547",
  null
  
)

export default component.exports